<template>
  <b-container class="p-3">
    <b-row class="mt-3 justify-content-center">
      <b-col cols="6" class="p-3">
        <b-img
          :src="require('@/assets/img/guider/happy-waving.png')"
          fluid
        />
      </b-col>
    </b-row>

    <b-row class="mt-3 justify-content-center">
      <b-col cols="10" class="text-justify">
        <p>
          &emsp;StarGuides menjunjung tinggi Kode Etik untuk semua guiders/mitra sehingga semua pemandu akan memiliki pemahaman yang jelas tentang hukum standar kepatuhan, keselamatan, keamanan dan pelayanan yang diharapkan dari mereka.
        </p>
      </b-col>
      <b-col cols="10" class="text-justify">
        <p>
          &emsp;Karena StarGuides mempertahankan kebijakan tanpa toleransi, pelanggaran dapat mengakibatkan penangguhan atau penghentian akses pengguna Situs Web www.starguides.co.
        </p>
      </b-col>
    </b-row>

    <b-row class="mt-3 justify-content-center">
      <b-col cols="10" class="text-justify" style="font-size: 18px;">
        <b-form-checkbox id='input-agreement' v-model="agreement">
          By clicking the button below, you agree to
          <router-link :to="{ name: 'TermsAndConditionGuider' }" style="color: #f27137; font-weight: 400;">StarGuides's Terms & Condition</router-link>
        </b-form-checkbox>
      </b-col>
    </b-row>

    <b-row class="mt-3 justify-content-center">
      <b-col cols="4">
        <b-button size="lg" variant="success" block @click="updateGuider" :disabled="btn_disabled">
          Become a Guider
        </b-button>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
// external dependencies
import swal from 'sweetalert'

// custom component

// api call
import UserAPI from '@/api/UserAPI'

export default {
  name: 'MyAccount_Settings_Become_A_Guider',
  props: ['user'],
  components: {
  },
  data () {
    return {
      agreement: false,
      btn_disabled: true,

      errors: []
    }
  },
  watch: {
    agreement: function (val) {
      if (val) this.btn_disabled = false
      else this.btn_disabled = true
    }
  },
  methods: {
    // PREREQUISITES
    updateGuider: async function () {
      try {
        await UserAPI.changeStatusGuiderCustomer({
          sg_user_id: this.user._id,
          type: `guider`
        })

        swal({
          title: 'Profile successfully updated!',
          icon: 'success',
          button: {
            text: 'Ok'
          }
        })

        this.$cookies.set('payment_data', {
          order_id: null,
          type_of_user: 'gd',
          type_of_order: 'registration',
          items: [{
            name: 'Registration Fee',
            desc: 'Guider registration, included StarGuides\'s Scarf',
            qty: 1,
            currency: 'EUR',
            price: 20
          }]
        })

        this.$router.push({name: 'Pay_Now'})
      } catch (error) {
        swal({
          title: 'Update profile error!',
          icon: 'error',
          button: {
            text: 'Ok'
          }
        })
      }
    }
    // END PREREQUISITES

    // HTTP REQUEST
    // END HTTP REQUEST
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/MyAccount/Settings/BecomeAGuider/BecomeAGuider.vue